/**
 * 监听歌词容器高度变化，用于计算上下留白（让高亮行尽量固定在中间）
 * 抽离自 MusicPlayer.js
 */
import { useEffect } from 'react';

/**
 * @param {object} options
 * @param {React.RefObject<HTMLElement|null>} options.lyricsContainerRef
 * @param {boolean} options.showLyrics
 * @param {function(number): void} options.setLyricsViewportHeight
 */
export function useLyricsViewportHeight({ lyricsContainerRef, showLyrics, setLyricsViewportHeight }) {
  useEffect(() => {
    if (!showLyrics) return;

    const container = lyricsContainerRef.current;
    if (!container) return;

    let rafId = 0;
    let lastH = -1;

    const updateHeightNow = () => {
      const h = container.clientHeight || 0;
      if (h === lastH) return;
      lastH = h;
      setLyricsViewportHeight(h);
    };

    const scheduleUpdateHeight = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        updateHeightNow();
      });
    };

    scheduleUpdateHeight();

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => scheduleUpdateHeight());
      ro.observe(container);
      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        ro.disconnect();
      };
    }

    window.addEventListener('resize', scheduleUpdateHeight);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('resize', scheduleUpdateHeight);
    };
  }, [showLyrics, lyricsContainerRef, setLyricsViewportHeight]);
}
